<div class="login-page-wrapper" *ngIf="!verifyEmailPage">
    <h1 class="main-heading">OTP Verification</h1>
    
    <form [formGroup]="otpForm" (ngSubmit)="onSubmit()" class="form-container">
        <div class="fields-container">
            <div class="otp-image text-center mb-4">
                <img src="/assets/img/Bidaya-long.png" class="otp-BackGround img-fluid" alt="Bidaya Home Finance">
            </div>
            
            <div class="otp-message text-center mb-4">
                <p class="description-text">
                    Enter the OTP sent to <span *ngIf="mobile">{{ mobile }}</span><span *ngIf="!mobile">your mobile number</span> and your email <span *ngIf="email">{{ email }}</span><span *ngIf="!email">address</span>
                </p>
            </div>
            
            <div class="otp-digits d-flex justify-content-center mb-4">
                <input type="text" class="otp-input" maxlength="1" id="otp1" formControlName="otp1" autofocus
                    appAutoTab (keypress)="onOtpKeyPress($event)" (input)="onOtpInput($event, 'otp1')" inputmode="numeric">
                <input type="text" class="otp-input" maxlength="1" id="otp2" formControlName="otp2" appAutoTab 
                    (keypress)="onOtpKeyPress($event)" (input)="onOtpInput($event, 'otp2')" inputmode="numeric">
                <input type="text" class="otp-input" maxlength="1" id="otp3" formControlName="otp3" appAutoTab 
                    (keypress)="onOtpKeyPress($event)" (input)="onOtpInput($event, 'otp3')" inputmode="numeric">
                <input type="text" class="otp-input" maxlength="1" id="otp4" formControlName="otp4" appAutoTab 
                    (keypress)="onOtpKeyPress($event)" (input)="onOtpInput($event, 'otp4')" inputmode="numeric">
            </div>
            
            <div class="text-danger text-center mt-2 mb-3" *ngIf="otpError">
                <small>{{ otpError }}</small>
            </div>
            
            <div class="submition d-flex justify-content-center">
                <button type="submit" class="submit-btn btn btn-primary">Submit</button>
            </div>
            
            <div class="resend-otp mt-3 text-center">
                <p class="dont-have-account mb-2">
                    If your code has expired, 
                    <a (click)="resendOTP()" [class.disabled]="resendTimer > 0" class="resend-link" [style.pointer-events]="resendTimer > 0 ? 'none' : 'auto'">
                        <strong>click here</strong>
                    </a> 
                    to resend OTP.
                </p>
                <p *ngIf="resendTimer > 0" class="timer-text">
                    <span class="timer-countdown">Please wait <strong>{{ resendTimer }}</strong> seconds before resending.</span>
                </p>
            </div>
        </div>
    </form>
</div>





<div class="form-container  w-75 bg-white rounded-5 my-5 shadow-lg" *ngIf="verifyEmailPage">
    <div class="fields-container m-5 ">
        <div class="container-title text-center">
            <p class="container-paragraph font-weight-bold">
                Email Verification Sent
            </p>
        </div>
        <div class="verification-image text-center mb-3">
            <div class="verification-image text-center mb-3">
                <i class="bi bi-envelope" style="font-size: 80px; color: #532E60;"></i>
            </div>


        </div>
        <div class="verification-message text-center mb-3">
            <label class="verification-label"> An email has been sent to your registered email address. Please
                check your inbox and click on the link to verify your email to complete your registeration
                process</label>
        </div>
        <div class="instructions text-center mb-2">
            <p>If you didn't receive the email, please check your spam folder</p>
        </div>
        <div class="d-flex justify-content-center mt-3">
            <a routerLink="/" class="submit-btn btn btn-primary">Go to Home</a>
        </div>
    </div>
</div>
